import React from "react";


//========================================================
// Workspace Drawer
//========================================================

export default function WorkspaceDrawer({

    visible,

    width = 540,

    right = 0,

    zIndex = 1000,

    children

})
{
    return (

        <div
            style={{
                ...styles.drawer,

                width: width,

                right:
                    visible
                        ? right
                        : -(width + 60),

                zIndex: zIndex
            }}
        >

            {children}

        </div>

    );

}


//========================================================
// Styles
//========================================================

const styles =
{
    drawer:
    {
        position: "fixed",

        top: 0,

        height: "100vh",

        display: "flex",

        flexDirection: "column",

        background:
            "linear-gradient(155deg, #101820 0%, #172633 55%, #1d3040 100%)",

        borderLeft:
            "1px solid rgba(255,255,255,0.08)",

        boxShadow:
            "-18px 0 50px rgba(0,0,0,0.28)",

        transition:
            "right 580ms cubic-bezier(0.4, 0, 0.2, 1)",

        overflow: "hidden"
    }
};